import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const COLORS = ["#EF4444", "#F59E0B", "#10B981", "#9CA3AF"];

const RADIAN = Math.PI / 180;

const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
}) => {
  if (percent === 0) return null;

  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor="middle"
      dominantBaseline="central"
      fontWeight="700"
      fontSize="16"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

export default function StagesPieChart({ progressData }) {
  let parsedProgressData = [];
  let total = 0;
  
  Object.entries(progressData).forEach((value) => {
    let obj = {};
    obj.name = value[0];
    obj.value = value[1];
    total += value[1];
    parsedProgressData.push(obj);
  });

  return (
    <Box
      sx={{
        backgroundColor: "#FFFFFF",
        borderRadius: 2,
        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
        p: 3,
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          fontSize: "1.125rem",
          color: "#1F2937",
          mb: 2,
        }}
      >
        Distribuição
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: 3,
          flex: 1,
        }}
      >
        <Box sx={{ width: "55%", height: 200 }}>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={parsedProgressData}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={renderCustomizedLabel}
                outerRadius={80}
                innerRadius={30}
                fill="#8884d8"
                dataKey="value"
              >
                {parsedProgressData.map((value, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            width: "45%",
          }}
        >
          {parsedProgressData.map((value, index) => {
            let parsedName = "";

            switch (value.name.toLowerCase()) {
              case "latedeadline":
                parsedName = "Em atraso";
                break;
              case "todaydeadline":
                parsedName = "Hoje";
                break;
              case "onschedule":
                parsedName = "No prazo";
                break;
            }

            return (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box display="flex" alignItems="center" gap={1}>
                  <Box
                    sx={{
                      width: 10,
                      height: 10,
                      backgroundColor: COLORS[index % COLORS.length],
                      borderRadius: "50%",
                      flexShrink: 0,
                    }}
                  />
                  <Typography variant="body2" color="text.secondary" fontSize="0.875rem">
                    {parsedName}
                  </Typography>
                </Box>
                <Typography variant="h6" fontWeight={700} color="text.primary" fontSize="1.125rem">
                  {value.value}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
}
